"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._richTextEditorFontMappings = exports.RichTextEditorContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const RichTextEditorContainer = exports.RichTextEditorContainer = _styledComponents.default.div`
	${({
  borderWidth,
  borderStyle,
  borderColor,
  borderRadius,
  backgroundColor,
  disabledBgColor,
  textColor,
  padding,
  margin,
  boxShadow
}) => `
		border-width: ${borderWidth ?? 1}px;
		border-style: ${borderStyle ?? 'solid'};
		border-color: ${borderColor ?? ' #ccc'};
		border-radius: ${borderRadius ?? 4}px;
		background-color: ${backgroundColor ?? ''};
		color: ${textColor ?? '#000'};
		padding: ${padding ?? '0'};
		margin: ${margin ?? '0'};
		${boxShadow}
	`}
`;

// Add font-family mappings for Quill font classes so the fonts render correctly in the editor
// Quill applies classes like `ql-font-<key>`; these map the keys declared in Font.whitelist
const _richTextEditorFontMappings = exports._richTextEditorFontMappings = `
    .ql-font-arial { font-family: Arial, Helvetica, sans-serif; }
    .ql-font-comic-sans { font-family: 'Comic Sans MS', 'Comic Sans', cursive; }
    .ql-font-courier-new { font-family: 'Courier New', Courier, monospace; }
    .ql-font-georgia { font-family: Georgia, 'Times New Roman', Times, serif; }
    .ql-font-helvetica { font-family: Helvetica, Arial, sans-serif; }
    .ql-font-lato { font-family: 'Lato', Arial, sans-serif; }
    .ql-font-lucida { font-family: 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida', sans-serif; }
    .ql-font-montserrat { font-family: 'Montserrat', Arial, sans-serif; }
    .ql-font-noto-sans { font-family: 'Noto Sans', Arial, sans-serif; }
    .ql-font-open-sans { font-family: 'Open Sans', Arial, sans-serif; }
    .ql-font-poppins { font-family: 'Poppins', Arial, sans-serif; }
    .ql-font-roboto { font-family: 'Roboto', Arial, sans-serif; }
    .ql-font-segoe-ui { font-family: 'Segoe UI', Tahoma, Geneva, sans-serif; }
    .ql-font-source-sans-pro { font-family: 'Source Sans Pro', Arial, sans-serif; }
    .ql-font-times-new-roman { font-family: 'Times New Roman', Times, serif; }
    .ql-font-trebuchet-ms { font-family: 'Trebuchet MS', 'Trebuchet', sans-serif; }
    .ql-font-verdana { font-family: Verdana, Geneva, sans-serif; }
`;

// Inject font mappings into the document's head when this module is imported (lightweight, avoids manual CSS edits)
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.setAttribute('data-richtext-fonts', 'true');
  // Also add picker labels for Quill's font dropdown (Quill uses ::before content on items)
  const pickerLabels = `
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="arial"]::before { content: "Arial"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="comic-sans"]::before { content: "Comic Sans"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="courier-new"]::before { content: "Courier New"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="georgia"]::before { content: "Georgia"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="helvetica"]::before { content: "Helvetica"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="lato"]::before { content: "Lato"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="lucida"]::before { content: "Lucida"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="montserrat"]::before { content: "Montserrat"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="noto-sans"]::before { content: "Noto Sans"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="open-sans"]::before { content: "Open Sans"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="poppins"]::before { content: "Poppins"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="roboto"]::before { content: "Roboto"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="segoe-ui"]::before { content: "Segoe UI"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="source-sans-pro"]::before { content: "Source Sans Pro"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="times-new-roman"]::before { content: "Times New Roman"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="trebuchet-ms"]::before { content: "Trebuchet MS"; }
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="verdana"]::before { content: "Verdana"; }
	`;
  // Also map the closed picker label (the button showing the currently selected font)
  const pickerLabelActive = `
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="arial"]::before { content: "Arial"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="comic-sans"]::before { content: "Comic Sans"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="courier-new"]::before { content: "Courier New"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="georgia"]::before { content: "Georgia"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="helvetica"]::before { content: "Helvetica"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="lato"]::before { content: "Lato"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="lucida"]::before { content: "Lucida"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="montserrat"]::before { content: "Montserrat"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="noto-sans"]::before { content: "Noto Sans"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="open-sans"]::before { content: "Open Sans"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="poppins"]::before { content: "Poppins"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="roboto"]::before { content: "Roboto"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="segoe-ui"]::before { content: "Segoe UI"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="source-sans-pro"]::before { content: "Source Sans Pro"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="times-new-roman"]::before { content: "Times New Roman"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="trebuchet-ms"]::before { content: "Trebuchet MS"; }
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="verdana"]::before { content: "Verdana"; }
	`;

  // Make the font dropdown scrollable when there are many fonts
  const pickerScrollStyles = `
		/* Limit font picker height and enable scrolling */
		.ql-snow .ql-picker.ql-font .ql-picker-options {
			max-height: 240px;
			overflow-y: auto;
			-webkit-overflow-scrolling: touch;
		}
		/* Optional: nicer thin scrollbar for WebKit */
		.ql-snow .ql-picker.ql-font .ql-picker-options::-webkit-scrollbar { width: 8px; }
		.ql-snow .ql-picker.ql-font .ql-picker-options::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.12); border-radius: 4px; }
	`;
  style.appendChild(document.createTextNode(_richTextEditorFontMappings + pickerLabels + pickerLabelActive + pickerScrollStyles));

  // Apply font-family to picker items and the closed picker label so each option displays in its own font
  const pickerItemFontStyles = `
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="arial"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="arial"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="arial"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="arial"]::before { font-family: Arial, Helvetica, sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="comic-sans"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="comic-sans"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="comic-sans"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="comic-sans"]::before { font-family: 'Comic Sans MS', 'Comic Sans', cursive; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="courier-new"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="courier-new"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="courier-new"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="courier-new"]::before { font-family: 'Courier New', Courier, monospace; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="georgia"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="georgia"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="georgia"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="georgia"]::before { font-family: Georgia, 'Times New Roman', Times, serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="helvetica"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="helvetica"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="helvetica"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="helvetica"]::before { font-family: Helvetica, Arial, sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="lato"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="lato"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="lato"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="lato"]::before { font-family: 'Lato', Arial, sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="lucida"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="lucida"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="lucida"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="lucida"]::before { font-family: 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida', sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="montserrat"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="montserrat"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="montserrat"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="montserrat"]::before { font-family: 'Montserrat', Arial, sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="noto-sans"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="noto-sans"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="noto-sans"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="noto-sans"]::before { font-family: 'Noto Sans', Arial, sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="open-sans"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="open-sans"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="open-sans"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="open-sans"]::before { font-family: 'Open Sans', Arial, sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="poppins"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="poppins"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="poppins"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="poppins"]::before { font-family: 'Poppins', Arial, sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="roboto"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="roboto"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="roboto"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="roboto"]::before { font-family: 'Roboto', Arial, sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="segoe-ui"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="segoe-ui"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="segoe-ui"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="segoe-ui"]::before { font-family: 'Segoe UI', Tahoma, Geneva, sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="source-sans-pro"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="source-sans-pro"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="source-sans-pro"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="source-sans-pro"]::before { font-family: 'Source Sans Pro', Arial, sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="times-new-roman"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="times-new-roman"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="times-new-roman"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="times-new-roman"]::before { font-family: 'Times New Roman', Times, serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="trebuchet-ms"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="trebuchet-ms"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="trebuchet-ms"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="trebuchet-ms"]::before { font-family: 'Trebuchet MS', 'Trebuchet', sans-serif; }

		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="verdana"],
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="verdana"]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="verdana"],
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="verdana"]::before { font-family: Verdana, Geneva, sans-serif; }
	`;
  style.appendChild(document.createTextNode(pickerItemFontStyles));
  document.head.appendChild(style);
}